import { useState, useEffect } from 'react'
import { listIncomePaymentAPI } from '../services/income/payment'

function UsePaymentListIncome(id) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await listIncomePaymentAPI({ paymentListTypeId: id })
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { ...d, value: d?.paymentListId, label: d?.paymentName }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    if (id) {
      getData()
    }
  }, [id])
  return data
}

export default UsePaymentListIncome
